var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileAppDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#Degradado_sin_nombre_147);}.cls-5{fill:#bedaff;}.cls-6{fill:#00e9ff;}.cls-7{fill:#3a55ca;}.cls-8{fill:#0382ff;}.cls-9{fill:#c3e0fe;}.cls-10{fill:url(#Degradado_sin_nombre_13);}.cls-11{fill:url(#Degradado_sin_nombre_13-2);}.cls-12{fill:url(#Degradado_sin_nombre_13-3);}.cls-13{fill:url(#Degradado_sin_nombre_13-4);}.cls-14{fill:url(#Degradado_sin_nombre_8);}.cls-15{fill:url(#Degradado_sin_nombre_4);}.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-29,.cls-31{mix-blend-mode:overlay;}.cls-16{fill:url(#Degradado_sin_nombre_4-2);}.cls-17{fill:url(#Degradado_sin_nombre_4-3);}.cls-18{fill:url(#Degradado_sin_nombre_4-4);}.cls-19{fill:url(#Degradado_sin_nombre_4-5);}.cls-20{fill:url(#Degradado_sin_nombre_4-6);}.cls-21{fill:url(#Degradado_sin_nombre_4-7);}.cls-22{fill:url(#Degradado_sin_nombre_145);}.cls-23{fill:#a9bdea;}.cls-24{mix-blend-mode:screen;fill:url(#Degradado_sin_nombre_144);}.cls-25{fill:url(#Degradado_sin_nombre_10);}.cls-26{fill:#a3b9e8;}.cls-27{fill:#7b97c9;}.cls-28{fill:#90a9d6;}.cls-29{opacity:0.32;}.cls-30{fill:#fff;}.cls-31{fill:url(#Degradado_sin_nombre_142);}.cls-32{fill:url(#Degradado_sin_nombre_6);}.cls-33{fill:#2645b5;}.cls-34{fill:#335185;}.cls-35{fill:#9cc0e8;}.cls-36{fill:url(#Degradado_sin_nombre_4-8);}.cls-37{fill:url(#Degradado_sin_nombre_4-9);}.cls-38{fill:url(#Degradado_sin_nombre_4-10);}.cls-39{fill:url(#Degradado_sin_nombre_10-2);}.cls-40{fill:#bdcefa;}.cls-41{fill:url(#Degradado_sin_nombre_4-11);}.cls-42{fill:url(#Degradado_sin_nombre_10-3);}.cls-43,.cls-45,.cls-47,.cls-49,.cls-51,.cls-53{mix-blend-mode:color-dodge;}.cls-43{fill:url(#Degradado_sin_nombre_9);}.cls-44{fill:url(#Degradado_sin_nombre_10-4);}.cls-45{fill:url(#Degradado_sin_nombre_9-2);}.cls-46{fill:url(#Degradado_sin_nombre_10-5);}.cls-47{fill:url(#Degradado_sin_nombre_9-3);}.cls-48{fill:url(#Degradado_sin_nombre_10-6);}.cls-49{fill:url(#Degradado_sin_nombre_9-4);}.cls-50{fill:url(#Degradado_sin_nombre_10-7);}.cls-51{fill:url(#Degradado_sin_nombre_9-5);}.cls-52{fill:url(#Degradado_sin_nombre_10-8);}.cls-53{fill:url(#Degradado_sin_nombre_9-6);}.cls-54{fill:#2d0d60;}.cls-55{fill:#fcc4b7;}.cls-56{fill:#293677;}.cls-57{fill:#dd936f;}.cls-58{fill:#b25e02;}.cls-108,.cls-58{fill-rule:evenodd;}.cls-59{fill:#fefefe;}.cls-60{fill:url(#Degradado_sin_nombre_5);}.cls-61{fill:url(#Degradado_sin_nombre_5-2);}.cls-62{fill:url(#Degradado_sin_nombre_5-3);}.cls-63{fill:url(#Degradado_sin_nombre_5-4);}.cls-64{fill:url(#Degradado_sin_nombre_5-5);}.cls-65{fill:url(#Degradado_sin_nombre_5-6);}.cls-66{fill:url(#Degradado_sin_nombre_5-7);}.cls-67{fill:url(#Degradado_sin_nombre_5-8);}.cls-68{fill:url(#Degradado_sin_nombre_5-9);}.cls-69{fill:url(#Degradado_sin_nombre_5-10);}.cls-70{fill:url(#Degradado_sin_nombre_5-11);}.cls-71{fill:url(#Degradado_sin_nombre_5-12);}.cls-72{fill:url(#Degradado_sin_nombre_5-13);}.cls-73{fill:url(#Degradado_sin_nombre_5-14);}.cls-74{fill:url(#Degradado_sin_nombre_5-15);}.cls-75{fill:url(#Degradado_sin_nombre_5-16);}.cls-76{fill:url(#Degradado_sin_nombre_5-17);}.cls-77{fill:url(#Degradado_sin_nombre_5-18);}.cls-78{fill:url(#Degradado_sin_nombre_5-19);}.cls-79{fill:url(#Degradado_sin_nombre_5-20);}.cls-80{fill:url(#Degradado_sin_nombre_5-21);}.cls-81{fill:url(#Degradado_sin_nombre_5-22);}.cls-82{fill:url(#Degradado_sin_nombre_8-2);}.cls-83{fill:url(#Degradado_sin_nombre_6-2);}.cls-84{fill:url(#Degradado_sin_nombre_137);}.cls-85{fill:url(#Degradado_sin_nombre_136);}.cls-86{fill:url(#Degradado_sin_nombre_4-12);}.cls-87{fill:url(#Degradado_sin_nombre_4-13);}.cls-88{fill:#484968;}.cls-89{fill:#f1ac85;}.cls-90{fill:#943bbb;}.cls-91{fill:#8800bf;}.cls-92{fill:#ffffeb;}.cls-93{fill:url(#Degradado_sin_nombre_5-23);}.cls-94{fill:#010400;}.cls-95{fill:#e28c66;}.cls-96{fill:url(#Degradado_sin_nombre_4-14);}.cls-97{fill:url(#Degradado_sin_nombre_4-15);}.cls-98{fill:url(#Degradado_sin_nombre_4-16);}.cls-99{fill:url(#Degradado_sin_nombre_4-17);}.cls-100{fill:url(#Degradado_sin_nombre_4-18);}.cls-101{fill:url(#Degradado_sin_nombre_2);}.cls-102{fill:#b6b9fe;}.cls-103{fill:#f9ab83;}.cls-104{fill:#2d2d4f;}.cls-105{fill:#1c1c38;}.cls-106{fill:#46466c;}.cls-107{fill:#e5a89c;}.cls-108{fill:#e58800;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_147",
    cx: -487.8,
    cy: 776.58,
    r: 222.21,
    gradientTransform: "matrix(0.87, -0.5, 0.87, 0.5, -31.22, -306.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eafdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_13",
    cx: 128.35,
    cy: 46.42,
    r: 20.77,
    gradientTransform: "translate(146.4 -80.25) rotate(76.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#e1efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c7d7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#bdcefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c4d3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#d8e2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f7f9fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_13-2",
    cx: 106.82,
    cy: 94.46,
    r: 9.99,
    gradientTransform: "translate(175.43 -26.83) rotate(76.8)",
    xlinkHref: "#Degradado_sin_nombre_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_13-3",
    cx: 395.59,
    cy: 381.2,
    r: 14.59,
    gradientTransform: "translate(677.88 -84.76) rotate(76.8)",
    xlinkHref: "#Degradado_sin_nombre_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_13-4",
    cx: 427.64,
    cy: 339.78,
    r: 19.04,
    gradientTransform: "translate(662.75 -146) rotate(76.8)",
    xlinkHref: "#Degradado_sin_nombre_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    x1: 224.88,
    y1: 251.78,
    x2: 470.94,
    y2: 104.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dfedfe",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d3e2fd",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#c9d9fc",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c3d3fb",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#bfcffa",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdcefa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 522.03,
    y1: 85.06,
    x2: 143.45,
    y2: 280.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f5f7fe",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e1e9fd",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d2ddfc",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c6d5fb",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#c0d0fa",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdcefa",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-2",
    x1: 505.07,
    y1: 52.25,
    x2: 126.49,
    y2: 247.99,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-3",
    x1: 506,
    y1: 54.06,
    x2: 127.43,
    y2: 249.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-4",
    x1: 535.7,
    y1: 111.5,
    x2: 157.13,
    y2: 307.24,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-5",
    x1: 537.68,
    y1: 115.32,
    x2: 159.1,
    y2: 311.06,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-6",
    x1: 540.35,
    y1: 120.49,
    x2: 161.77,
    y2: 316.23,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-7",
    x1: 543.02,
    y1: 125.66,
    x2: 164.45,
    y2: 321.4,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_145",
    x1: 243.85,
    y1: 54.1,
    x2: 118.64,
    y2: 370.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3e0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c1ddfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#abc3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3b9e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_144",
    x1: 212.6,
    y1: 8.95,
    x2: 93.58,
    y2: 334.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bedaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: 245.79,
    y1: 41.58,
    x2: 47.31,
    y2: 567.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#e1efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c7d7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdcefa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_142",
    x1: 182.6,
    y1: 61.95,
    x2: 182.6,
    y2: 320.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9bdea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    x1: 138.32,
    y1: 254.03,
    x2: 242.96,
    y2: 330.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#01d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#02a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#038cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0382ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-8",
    x1: 203.73,
    y1: 137.04,
    x2: 159.9,
    y2: 179.59,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-9",
    x1: 202.14,
    y1: 135.41,
    x2: 158.32,
    y2: 177.96,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-10",
    x1: 200.04,
    y1: 133.25,
    x2: 156.22,
    y2: 175.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-2",
    x1: 238.08,
    y1: 126.4,
    x2: 225.63,
    y2: 147.53,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-11",
    x1: 231.24,
    y1: 171.28,
    x2: 207.65,
    y2: 230.88,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-3",
    x1: 273.89,
    y1: 254.93,
    x2: 181.23,
    y2: 338.1,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    x1: 215.58,
    y1: 359.24,
    x2: 215.58,
    y2: 218.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#55d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4fc3ee",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#41a0c2",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#29677b",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0a191a",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-4",
    x1: 286.21,
    y1: 247.92,
    x2: 233.51,
    y2: 283.85,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-2",
    x1: 240.1,
    y1: 276.02,
    x2: 240.1,
    y2: 258.75,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-5",
    x1: 300.52,
    y1: 268.91,
    x2: 247.82,
    y2: 304.84,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-3",
    x1: 254.92,
    y1: 296.67,
    x2: 254.92,
    y2: 279.4,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-6",
    x1: 314.84,
    y1: 289.91,
    x2: 262.14,
    y2: 325.84,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-4",
    x1: 269.74,
    y1: 317.32,
    x2: 269.74,
    y2: 300.05,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-7",
    x1: 329.15,
    y1: 310.9,
    x2: 276.45,
    y2: 346.83,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-5",
    x1: 284.56,
    y1: 337.97,
    x2: 284.56,
    y2: 320.7,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-8",
    x1: 343.47,
    y1: 331.9,
    x2: 290.77,
    y2: 367.83,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-6",
    x1: 299.38,
    y1: 358.62,
    x2: 299.38,
    y2: 341.35,
    xlinkHref: "#Degradado_sin_nombre_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5",
    x1: 256.82,
    y1: 356.43,
    x2: 148.45,
    y2: 357.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#dae4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdcefa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-2",
    x1: 256.84,
    y1: 357.33,
    x2: 148.46,
    y2: 358.85,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-3",
    x1: 256.87,
    y1: 359.74,
    x2: 148.5,
    y2: 361.26,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-4",
    x1: 256.9,
    y1: 362.15,
    x2: 148.53,
    y2: 363.67,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-5",
    x1: 257.02,
    y1: 370.45,
    x2: 148.65,
    y2: 371.97,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-6",
    x1: 256.66,
    y1: 344.64,
    x2: 148.29,
    y2: 346.16,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-7",
    x1: 257,
    y1: 368.8,
    x2: 148.62,
    y2: 370.32,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-8",
    x1: 241.93,
    y1: 374.64,
    x2: 152.11,
    y2: 374.64,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-9",
    x1: 243.38,
    y1: 376.6,
    x2: 151.07,
    y2: 377.78,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-10",
    x1: 241.42,
    y1: 381.74,
    x2: 151.92,
    y2: 379.57,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-11",
    x1: 241.84,
    y1: 383.16,
    x2: 151.47,
    y2: 383.16,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-12",
    x1: 240.7,
    y1: 386,
    x2: 151.18,
    y2: 386,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-13",
    x1: 241.07,
    y1: 388.84,
    x2: 152.83,
    y2: 388.84,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-14",
    x1: 423.93,
    y1: 285.3,
    x2: 341.52,
    y2: 287.54,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-15",
    x1: 423.99,
    y1: 287.54,
    x2: 341.59,
    y2: 289.78,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-16",
    x1: 424.05,
    y1: 289.77,
    x2: 341.65,
    y2: 292.02,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-17",
    x1: 424.28,
    y1: 298.33,
    x2: 341.88,
    y2: 300.58,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-18",
    x1: 423.76,
    y1: 278.99,
    x2: 341.35,
    y2: 281.24,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-19",
    x1: 424.22,
    y1: 295.96,
    x2: 341.81,
    y2: 298.2,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-20",
    x1: 427.87,
    y1: 298.69,
    x2: 313.99,
    y2: 306.8,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-21",
    x1: 428.07,
    y1: 301.52,
    x2: 314.19,
    y2: 309.63,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-22",
    x1: 428.27,
    y1: 304.34,
    x2: 314.39,
    y2: 312.45,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8-2",
    x1: 308.39,
    y1: 427.44,
    x2: 256,
    y2: 430.91,
    xlinkHref: "#Degradado_sin_nombre_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-2",
    x1: 249.57,
    y1: 416.93,
    x2: 285.3,
    y2: 416.93,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_137",
    x1: 267.43,
    y1: 305.47,
    x2: 267.43,
    y2: 479.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_136",
    x1: 76.83,
    y1: 337.52,
    x2: 101.77,
    y2: 145.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0382ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#218bff",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8bacfe",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6b9fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-12",
    x1: 95.84,
    y1: 246.51,
    x2: -0.9,
    y2: 338.89,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-13",
    x1: 97,
    y1: 247.73,
    x2: 0.26,
    y2: 340.11,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-23",
    x1: 176.26,
    y1: 230.42,
    x2: 156.65,
    y2: 254.3,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-14",
    x1: 289.74,
    y1: 232.27,
    x2: 287.23,
    y2: 242.14,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-15",
    x1: 288.86,
    y1: 232.05,
    x2: 286.34,
    y2: 241.91,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-16",
    x1: 288.42,
    y1: 231.94,
    x2: 285.91,
    y2: 241.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-17",
    x1: 287.87,
    y1: 231.8,
    x2: 285.35,
    y2: 241.66,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-18",
    x1: 286.68,
    y1: 231.49,
    x2: 284.17,
    y2: 241.36,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: 269.18,
    y1: 248.7,
    x2: 284.19,
    y2: 248.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8347e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#773bd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#591ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d007e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-75.38,325.83,218.77,495.66,513.11,325.73,219,155.9ZM240.31,482l-21.54,12.44-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.44L174.7,469l21.54-12.43Zm-22.55-13-21.54,12.43L152.15,456l21.54-12.43Zm-22.55-13-21.53,12.43L129.6,443l21.54-12.44Zm-22.55-13L128.58,442.4,107.06,430l21.53-12.44Zm-22.54-13L106,429.39,84.51,417,106,404.53Zm-22.55-13L83.48,416.37,62,403.94,83.5,391.51Zm-22.55-13L60.93,403.35,39.41,390.92,61,378.49Zm-22.55-13L38.39,390.33,16.86,377.91,38.4,365.47Zm-22.55-13L15.84,377.31-5.69,364.89l21.54-12.44Zm-22.55-13L-6.71,364.29l-21.52-12.42L-6.7,339.44Zm-22.54-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43ZM262.87,469l-21.54,12.43L219.81,469l21.54-12.43Zm-22.55-13-21.54,12.43L197.26,456l21.54-12.44Zm-22.55-13-21.53,12.43L174.71,443l21.54-12.44Zm-22.55-13L173.69,442.4,152.17,430l21.53-12.43Zm-22.54-13-21.54,12.44L129.62,417l21.53-12.43Zm-22.55-13-21.54,12.43-21.52-12.43,21.54-12.43Zm-22.55-13L106,403.34,84.52,390.92l21.54-12.44Zm-22.55-13L83.5,390.32,62,377.9l21.54-12.44Zm-22.55-13L61,377.3,39.43,364.88,61,352.45Zm-22.54-13L38.4,364.29,16.88,351.86l21.53-12.43Zm-22.55-13L15.85,351.27-5.67,338.84l21.54-12.43Zm-22.55-13L-6.7,338.25l-21.52-12.43,21.54-12.43Zm-22.55-13-21.53,12.43-21.53-12.42,21.54-12.44ZM285.43,456,263.9,468.42,242.37,456l21.54-12.44Zm-22.55-13-21.53,12.44L219.83,443l21.53-12.43Zm-22.54-13L218.8,442.39,197.28,430l21.53-12.43Zm-22.55-13-21.54,12.43-21.52-12.43,21.54-12.43Zm-22.55-13L173.7,416.35l-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.53,12.43-21.53-12.42,21.54-12.44Zm-22.55-13L106.06,377.3,84.54,364.87l21.53-12.43Zm-22.54-13L83.51,364.28,62,351.85l21.53-12.43Zm-22.55-13L61,351.26,39.44,338.83,61,326.4ZM60,325.81,38.41,338.24,16.89,325.82l21.54-12.44Zm-22.55-13L15.87,325.22-5.66,312.8l21.54-12.44Zm-22.55-13L-6.68,312.21-28.2,299.78l21.53-12.43ZM308,443,286.46,455.4,264.94,443l21.53-12.43Zm-22.54-13-21.54,12.43L242.39,430l21.53-12.43Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.53,12.43L174.74,390.9l21.54-12.43Zm-22.55-13-21.53,12.44-21.53-12.43,21.54-12.43Zm-22.55-13-21.53,12.44-21.52-12.43,21.53-12.43Zm-22.54-13-21.54,12.43L107.1,351.84l21.53-12.43Zm-22.55-13-21.54,12.43L84.55,338.83l21.54-12.44Zm-22.55-13L83.52,338.23,62,325.81l21.54-12.44Zm-22.55-13L61,325.22,39.45,312.79,61,300.36ZM60,299.76,38.43,312.2,16.91,299.77l21.53-12.43Zm-22.54-13L15.88,299.18-5.64,286.75l21.53-12.43ZM330.56,429.94,309,442.37,287.5,430,309,417.51Zm-22.55-13-21.54,12.43L265,416.93l21.54-12.44Zm-22.55-13-21.54,12.43L242.4,403.91l21.54-12.43Zm-22.55-13-21.53,12.44-21.53-12.43,21.54-12.43Zm-22.55-13L218.83,390.3l-21.52-12.43,21.53-12.43Zm-22.54-13-21.54,12.43-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.44L107.11,325.8l21.54-12.43Zm-22.55-13-21.53,12.44L84.56,312.78l21.54-12.43Zm-22.55-13L83.54,312.19,62,299.76l21.53-12.43Zm-22.54-13L61,299.17,39.47,286.75,61,274.31ZM60,273.72,38.44,286.15,16.92,273.73l21.54-12.44ZM353.12,416.91l-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13L309,416.33,287.51,403.9l21.54-12.43Zm-22.55-13-21.53,12.44L265,390.88l21.54-12.43Zm-22.54-13-21.54,12.43-21.52-12.43L264,365.43Zm-22.55-13-21.54,12.43-21.52-12.42,21.53-12.44Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.53,12.44-21.53-12.43,21.54-12.43Zm-22.55-13L151.2,325.2l-21.52-12.43,21.53-12.43Zm-22.54-13-21.54,12.43-21.52-12.42,21.53-12.44Zm-22.55-13L106.1,299.16,84.58,286.74l21.54-12.44Zm-22.55-13L83.55,286.14,62,273.72l21.54-12.44Zm-22.55-13L61,273.13,39.48,260.7,61,248.27ZM375.68,403.88l-21.53,12.44-21.53-12.43,21.54-12.43Zm-22.55-13L331.6,403.3l-21.52-12.43,21.53-12.43Zm-22.54-13-21.54,12.43-21.52-12.42,21.53-12.44Zm-22.55-13L286.5,377.26,265,364.84l21.54-12.44Zm-22.55-13L264,364.25l-21.52-12.43L264,339.39Zm-22.55-13L241.4,351.23,219.88,338.8l21.54-12.43Zm-22.55-13-21.53,12.44-21.53-12.43,21.54-12.43Zm-22.55-13-21.53,12.43-21.52-12.43,21.53-12.43Zm-22.54-13-21.54,12.43-21.52-12.42,21.53-12.44Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.53,12.44L84.59,260.69l21.54-12.43Zm-22.55-13L83.57,260.1,62.05,247.67l21.53-12.43ZM398.24,390.86l-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13-21.54,12.43-21.52-12.42,21.53-12.44Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.53,12.44L265,338.79l21.54-12.43Zm-22.55-13L264,338.2l-21.52-12.43L264,313.34Zm-22.54-13-21.54,12.43L219.9,312.76l21.53-12.44Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.54,12.44L174.8,286.72l21.54-12.43Zm-22.55-13-21.54,12.44L152.25,273.7l21.54-12.43Zm-22.55-13-21.53,12.43L129.7,260.68l21.54-12.43Zm-22.55-13-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13-21.54,12.43L84.61,234.65l21.53-12.44ZM420.81,377.83l-21.54,12.43-21.52-12.42,21.53-12.43Zm-22.55-13-21.54,12.44L355.2,364.82l21.54-12.43Zm-22.55-13-21.54,12.44L332.65,351.8l21.54-12.43Zm-22.55-13-21.53,12.43L310.1,338.78l21.54-12.43Zm-22.55-13-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13-21.54,12.43L265,312.75l21.53-12.44Zm-22.55-13L264,312.16l-21.52-12.43L264,287.3ZM263,286.7l-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.53,12.43-21.53-12.43,21.54-12.43Zm-22.55-13L196.34,273.1l-21.53-12.42,21.54-12.44Zm-22.55-13-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13-21.54,12.43-21.52-12.42,21.54-12.43Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43ZM443.37,364.8l-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.54,12.43-21.52-12.43,21.54-12.43Zm-22.55-13L376.74,351.2l-21.53-12.42,21.54-12.44Zm-22.55-13-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13-21.54,12.44-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13-21.54,12.43L265,286.7l21.54-12.43Zm-22.55-13L264,286.11l-21.53-12.42L264,261.25Zm-22.55-13-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13L218.9,260.07l-21.52-12.42,21.53-12.43Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13L173.8,234l-21.52-12.43,21.54-12.43Zm-22.55-13L151.26,221l-21.53-12.43,21.54-12.43ZM465.93,351.78,444.4,364.21l-21.53-12.42,21.54-12.44Zm-22.55-13-21.53,12.43-21.52-12.42,21.53-12.44Zm-22.54-13L399.3,338.18l-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13L354.2,312.14l-21.52-12.43,21.54-12.43Zm-22.55-13-21.54,12.43L310.13,286.7l21.54-12.44Zm-22.55-13L309.11,286.1l-21.53-12.42,21.54-12.44Zm-22.55-13-21.53,12.43L265,260.66l21.53-12.43Zm-22.54-13L264,260.07l-21.52-12.43L264,235.21Zm-22.55-13-21.54,12.44-21.52-12.43,21.54-12.43Zm-22.55-13L218.91,234,197.39,221.6l21.54-12.43Zm-22.55-13L196.37,221l-21.53-12.42,21.54-12.44Zm-22.55-13L173.82,208,152.3,195.57l21.53-12.44ZM488.49,338.75,467,351.19l-21.52-12.43L467,326.33Zm-22.54-13-21.54,12.44-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.43-21.52-12.43,21.54-12.43Zm-22.55-13-21.54,12.43-21.52-12.42,21.54-12.44Zm-22.55-13-21.53,12.43-21.53-12.42,21.54-12.44Zm-22.55-13-21.53,12.43-21.53-12.42,21.54-12.43Zm-22.54-13-21.54,12.44-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.44L287.6,247.63l21.54-12.43Zm-22.55-13L286.57,247l-21.52-12.43,21.54-12.43Zm-22.55-13L264,234,242.5,221.6,264,209.16Zm-22.55-13L241.48,221,220,208.58l21.54-12.44Zm-22.55-13L218.93,208l-21.52-12.43,21.53-12.43Zm-22.54-13L196.38,195l-21.52-12.43,21.53-12.43Zm293.14,143.2-21.54,12.43L468,325.73l21.53-12.43Zm-22.55-13L467,325.14l-21.52-12.42L467,300.28Zm-22.55-13-21.54,12.43L422.9,299.7l21.54-12.44Zm-22.55-13L421.88,299.1l-21.53-12.42,21.54-12.43Zm-22.55-13-21.53,12.44-21.52-12.43,21.53-12.43Zm-22.54-13-21.54,12.44-21.52-12.43,21.53-12.43Zm-22.55-13-21.54,12.43-21.52-12.43,21.54-12.43Zm-22.55-13L331.68,247l-21.52-12.42,21.54-12.44Zm-22.55-13L309.14,234l-21.53-12.42,21.54-12.44Zm-22.55-13L286.59,221l-21.53-12.43,21.54-12.43Zm-22.55-13L264,208l-21.52-12.43,21.53-12.43Zm-22.54-13L241.49,195,220,182.53l21.54-12.43Zm-22.55-13-21.54,12.43-21.52-12.42L219,157.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.64,231l-3.71,2.14c-1.93,1.11-1.93,2.92,0,4l3.71,2.14a7.75,7.75,0,0,0,7,0l3.7-2.14c1.93-1.11,1.93-2.92,0-4l-3.7-2.14A7.69,7.69,0,0,0,318.64,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.76,268.52h0c1.93,1.12,1.93,2.92,0,4l-2.61,1.5c-1.93,1.12-1.93,2.92,0,4l3.7,2.14a7.75,7.75,0,0,0,7,0l3.71-2.14c1.93-1.12,1.93-2.92,0-4l-2.84-1.63c-1.93-1.12-1.93-2.92,0-4L339,260.7a7.75,7.75,0,0,1,7,0l.9.52a7.69,7.69,0,0,0,7,0l3.7-2.13c1.93-1.12,1.93-2.93,0-4l-3.7-2.14a7.75,7.75,0,0,0-7,0l-2.35,1.36a7.69,7.69,0,0,1-7,0l-13-7.48a7.69,7.69,0,0,0-7,0l-5.07,2.93a7.75,7.75,0,0,1-7,0l-3.44-2a7.69,7.69,0,0,0-7,0l-3.7,2.14c-1.93,1.11-1.93,2.92,0,4l3.44,2c1.93,1.11,1.93,2.92,0,4l-5.36,3.1c-1.93,1.11-1.93,2.92,0,4l7.9,4.57a7.75,7.75,0,0,0,7,0l5.36-3.1A7.75,7.75,0,0,1,316.76,268.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.93,408.32,92,406c2.11-1.22,2.11-3.2,0-4.42l-4-2.33a8.43,8.43,0,0,0-7.64,0l-4.05,2.33c-2.11,1.22-2.11,3.2,0,4.42l4.05,2.33A8.43,8.43,0,0,0,87.93,408.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90,367.29h0c-2.11-1.22-2.11-3.2,0-4.41l2.85-1.65c2.11-1.22,2.11-3.19,0-4.41l-4-2.34a8.43,8.43,0,0,0-7.64,0l-4,2.34C75,358,75,360,77.1,361.23L80.19,363c2.12,1.22,2.12,3.19,0,4.41l-14.55,8.41a8.51,8.51,0,0,1-7.65,0l-1-.57a8.43,8.43,0,0,0-7.64,0l-4,2.33c-2.11,1.22-2.11,3.2,0,4.42l4,2.33a8.43,8.43,0,0,0,7.64,0l2.57-1.48a8.43,8.43,0,0,1,7.64,0l14.17,8.18a8.43,8.43,0,0,0,7.64,0l5.54-3.2a8.45,8.45,0,0,1,7.65,0L106,390a8.43,8.43,0,0,0,7.64,0l4-2.34c2.11-1.21,2.11-3.19,0-4.41l-3.77-2.17c-2.11-1.22-2.11-3.19,0-4.41l5.86-3.38c2.11-1.22,2.11-3.2,0-4.42l-8.64-5a8.49,8.49,0,0,0-7.64,0l-5.86,3.39A8.43,8.43,0,0,1,90,367.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.93,174.77a16.56,16.56,0,0,0-7.49,13c0,4.77,3.36,6.7,7.49,4.32a16.55,16.55,0,0,0,7.48-13C107.41,174.32,104.06,172.39,99.93,174.77Zm0,14.32c-2.72,1.57-4.92.3-4.92-2.84a10.86,10.86,0,0,1,4.92-8.51c2.71-1.56,4.91-.29,4.91,2.84A10.88,10.88,0,0,1,99.93,189.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96.79,207a9,9,0,0,1-4.09,7.09c-2.26,1.31-4.1.25-4.1-2.36a9.06,9.06,0,0,1,4.1-7.09C95,203.31,96.79,204.36,96.79,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101,158.7a9,9,0,0,1-4.09,7.09c-2.26,1.31-4.09.25-4.09-2.36a9.05,9.05,0,0,1,4.09-7.09C99.2,155,101,156.09,101,158.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 75.29,
    y: 194.53,
    width: 11.67,
    height: 6.73,
    transform: "translate(-130.82 169.21) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.46,173.23l-3.41,2v-3.94c0-.72-.51-1-1.14-.65a2.51,2.51,0,0,0-1.13,2v3.94l-3.41,2a2.5,2.5,0,0,0-1.14,2c0,.72.51,1,1.14.65l3.41-2v3.94c0,.73.51,1,1.13.66a2.52,2.52,0,0,0,1.14-2v-3.94l3.41-2a2.49,2.49,0,0,0,1.13-2C84.59,173.16,84.09,172.87,83.46,173.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M270.81,104.3a16.54,16.54,0,0,0-7.49,13c0,4.77,3.35,6.7,7.49,4.32a16.55,16.55,0,0,0,7.48-13C278.29,103.85,274.94,101.92,270.81,104.3Zm0,14.32c-2.72,1.57-4.92.3-4.92-2.84a10.86,10.86,0,0,1,4.92-8.51c2.71-1.57,4.91-.3,4.91,2.84A10.88,10.88,0,0,1,270.81,118.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.34,131.73a9.06,9.06,0,0,1-4.1,7.09c-2.26,1.3-4.09.25-4.09-2.36a9,9,0,0,1,4.09-7.09C263.5,128.06,265.34,129.12,265.34,131.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M271.43,87.75a9.05,9.05,0,0,1-4.09,7.09c-2.26,1.3-4.09.24-4.09-2.37a9.05,9.05,0,0,1,4.09-7.09C269.6,84.08,271.43,85.14,271.43,87.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 243.84,
    y: 119.29,
    width: 11.67,
    height: 6.73,
    transform: "translate(18.61 277.55) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M257.69,97.75l-3.42,2V95.78c0-.73-.5-1-1.13-.66a2.49,2.49,0,0,0-1.13,2V101l-3.42,2a2.51,2.51,0,0,0-1.13,2c0,.72.51,1,1.13.65l3.42-2v3.94c0,.73.5,1,1.13.66a2.49,2.49,0,0,0,1.13-2v-3.94l3.42-2a2.55,2.55,0,0,0,1.13-2C258.82,97.68,258.31,97.38,257.69,97.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 123.83,
    cy: 52.24,
    r: 13.69,
    transform: "translate(44.69 160.86) rotate(-76.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 104.64,
    cy: 97.26,
    r: 6.59,
    transform: "translate(-13.95 176.93) rotate(-76.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 392.41,
    cy: 385.29,
    r: 9.62,
    transform: "translate(-72.32 679.32) rotate(-76.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 423.49,
    cy: 345.12,
    r: 12.55,
    transform: "translate(-9.24 678.58) rotate(-76.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M440.65,266.5,311.46,191.91a15.41,15.41,0,0,1-7.71-13.35V59.94a15.42,15.42,0,0,1,23.12-13.35l129.19,74.59a15.41,15.41,0,0,1,7.71,13.35V253.15A15.41,15.41,0,0,1,440.65,266.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M448.33,263.42a10.16,10.16,0,0,1-5.1-1.39L314,187.44a10.29,10.29,0,0,1-5.12-8.88V59.94a10.29,10.29,0,0,1,10.27-10.27,10.07,10.07,0,0,1,5.1,1.4l129.19,74.59a10.26,10.26,0,0,1,5.12,8.87V253.15A10.29,10.29,0,0,1,448.33,263.42ZM319.19,50.67a9.29,9.29,0,0,0-9.27,9.27V178.56a9.26,9.26,0,0,0,4.62,8l129.19,74.59a9.08,9.08,0,0,0,4.6,1.26,9.29,9.29,0,0,0,9.27-9.27V134.53a9.28,9.28,0,0,0-4.62-8L323.79,51.93A9.18,9.18,0,0,0,319.19,50.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M442.17,151.85,330.61,87.45c-2.49-1.44-4.53-5.34-4.53-8.66h0c0-3.32,2-4.86,4.53-3.42l111.56,64.4c2.49,1.44,4.52,5.34,4.52,8.66h0C446.69,151.75,444.66,153.29,442.17,151.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M367.64,170.63l-35.4-20.43c-2.49-1.44-4.53-5.34-4.53-8.66V102.29c0-3.33,2-4.87,4.53-3.43l35.4,20.44c2.49,1.44,4.53,5.33,4.53,8.66v39.25C372.17,170.53,370.13,172.07,367.64,170.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M434.15,209,398.76,188.6c-2.49-1.44-4.53-5.33-4.53-8.66V140.69c0-3.32,2-4.86,4.53-3.42l35.39,20.43c2.5,1.44,4.54,5.34,4.54,8.66v39.25C438.69,208.93,436.65,210.48,434.15,209Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M440.59,230,325.8,163.77a3.08,3.08,0,0,1-1.28-2.46h0c0-.95.57-1.39,1.28-1l114.79,66.28a3.06,3.06,0,0,1,1.29,2.46h0C441.88,230,441.31,230.46,440.59,230Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M440.59,236.6,325.8,170.32a3.08,3.08,0,0,1-1.28-2.46h0c0-1,.57-1.39,1.28-1l114.79,66.28a3.06,3.06,0,0,1,1.29,2.46h0C441.88,236.57,441.31,237,440.59,236.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M440.59,243.15,325.8,176.87a3.08,3.08,0,0,1-1.28-2.46h0c0-.95.57-1.39,1.28-1l114.79,66.27a3.06,3.06,0,0,1,1.29,2.46h0C441.88,243.12,441.31,243.56,440.59,243.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M124.68,357.47v-227c0-6.27,3.81-13.56,8.52-16.28L230.47,58c4.71-2.71,8.52.17,8.52,6.44v227c0,6.28-3.82,13.57-8.52,16.29L133.2,363.92C128.49,366.63,124.68,363.75,124.68,357.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M236.07,57.61h0l-.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M127,363.92c-1.44-1.21-2.32-3.43-2.32-6.45v-227c0-6.27,3.81-13.56,8.52-16.28L230.47,58c2.06-1.18,3.94-1.3,5.41-.53l-5.19-3c-1.54-1.22-3.7-1.29-6.09.09l-97.27,56.16c-4.71,2.72-8.52,10-8.52,16.28v227c0,3.76,1.38,6.29,3.49,7.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M128.38,364.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M128.39,364.71ZM229.65,57.76l-97.27,56.16c-4.71,2.72-8.52,10-8.52,16.28v227a8.79,8.79,0,0,0,1.84,6l1.3.75c-1.44-1.21-2.32-3.43-2.32-6.45v-227c0-6.27,3.81-13.56,8.52-16.28L230.47,58a6.12,6.12,0,0,1,4.36-.91A5.63,5.63,0,0,0,229.65,57.76Zm6.25-.26.17.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M229.83,62.69l-16.78,9.69-2.52,6.32a14.88,14.88,0,0,1-5.82,7.18L159,112.29c-2.39,1.38-4.6,1.2-5.82-.45l-2.52-3.41-16.79,9.69a12,12,0,0,0-5.44,9.42V356.11c0,3.47,2.44,4.88,5.44,3.14l96-55.42a12,12,0,0,0,5.44-9.42V65.83C235.27,62.36,232.84,61,229.83,62.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M196.7,85.82,167,103c-.53.31-1,0-1-.73h0a2.34,2.34,0,0,1,1-1.85L196.7,83.24c.53-.31,1,0,1,.73h0A2.33,2.33,0,0,1,196.7,85.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M122.24,190.14l-.14-.09a2.35,2.35,0,0,1-1-1.87V167.36c0-.72.45-1.05,1-.74l.14.08a2.36,2.36,0,0,1,1,1.88V189.4C123.22,190.12,122.78,190.45,122.24,190.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M121.15,190.14l-.14-.09a2.35,2.35,0,0,1-1-1.87V167.36c0-.72.45-1.05,1-.74l.14.08a2.36,2.36,0,0,1,1,1.88V189.4C122.13,190.12,121.69,190.45,121.15,190.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M218,61.27a1,1,0,0,1,0,2,3.75,3.75,0,0,1-3.39,0,1,1,0,0,1,0-2A3.75,3.75,0,0,1,218,61.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M218,61.27a3.75,3.75,0,0,0-3.39,0,1.61,1.61,0,0,0-.54.48l.21-.15a3.75,3.75,0,0,1,3.39,0c.7.4.87,1,.54,1.49C218.92,62.54,218.86,61.77,218,61.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "235.24 173.94 235.24 97.78 128.37 204.66 128.37 280.82 235.24 173.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M128.37,182.28,235.24,75.4V65.83c0-3.47-2.43-4.87-5.44-3.14l-8.58,5-10.5,10.49-.22.56a14.83,14.83,0,0,1-5.82,7.18l-4,2.3L128.37,160.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "235.24 234.79 235.24 191.04 128.37 297.92 128.37 341.67 235.24 234.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "235.24 274.18 235.24 264.17 148.84 350.57 172.52 336.9 235.24 274.18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M204.71,85.88,159,112.29c-2.39,1.38-4.6,1.2-5.82-.45l-2.52-3.41-16.79,9.69a11.21,11.21,0,0,0-3.91,4.18,10.23,10.23,0,0,1,2.82-2.55l16.79-9.69,2.52,3.41c1.22,1.66,3.43,1.83,5.82.45l45.74-26.41a13.83,13.83,0,0,0,4.79-5.05A13,13,0,0,1,204.71,85.88Zm25.12-23.19-16.78,9.69-.52,1.31,16.21-9.36c3-1.74,5.44-.33,5.44,3.14V296a11.08,11.08,0,0,1-1.52,5.24,11.89,11.89,0,0,0,2.61-6.87V65.83C235.27,62.36,232.84,61,229.83,62.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.71,192.62l-29.47,17c-2.06,1.19-3.73-.07-3.73-2.81h0c0-2.75,1.67-5.93,3.73-7.12l29.47-17c2-1.19,3.72.07,3.72,2.81h0C171.43,188.24,169.76,191.43,167.71,192.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M178.25,200.35l-40,23.1c-2.06,1.19-3.73-.07-3.73-2.81h0c0-2.74,1.67-5.93,3.73-7.12l40-23.1c2.05-1.19,3.72.08,3.72,2.82h0C182,196,180.3,199.17,178.25,200.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M160.67,224.32l-22.43,13c-2.06,1.18-3.73-.08-3.73-2.82h0c0-2.74,1.67-5.93,3.73-7.12l22.43-13c2.06-1.18,3.72.08,3.72,2.82h0C164.39,220,162.73,223.14,160.67,224.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M224.9,293.22,140.41,342c-3.29,1.9-6-.13-6-4.52V291.33c0-4.39,2.69-9.53,6-11.42l84.49-48.78c3.29-1.9,6,.13,6,4.51V281.8C230.88,286.19,228.19,291.32,224.9,293.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M231,97.8V93.6c0-3.62-2.54-5.09-5.68-3.28l-85.2,49.19a12.55,12.55,0,0,0-5.68,9.84v4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.46,142.38a5.05,5.05,0,0,1-2.28,4c-1.26.73-2.29.14-2.29-1.32a5.06,5.06,0,0,1,2.29-4C143.44,140.33,144.46,140.92,144.46,142.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.5,137.74a5.06,5.06,0,0,1-2.29,4c-1.26.73-2.29.14-2.29-1.32a5.08,5.08,0,0,1,2.29-4C151.47,135.7,152.5,136.29,152.5,137.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.53,133.11a5,5,0,0,1-2.29,3.95c-1.26.73-2.28.14-2.28-1.31a5.05,5.05,0,0,1,2.28-4C159.5,131.06,160.53,131.65,160.53,133.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M149.37,170.54l7.95,10c-6.37,8.29-14.81,11.55-19.55,7.54-2-1.68-3.16-4.51-3.32-8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.37,170.54l-14.92,9.51c-.25-5.36,1.8-11.86,5.51-17.48,3.57-5.41,8.29-9.39,12.77-10.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.34,175.17l3.35-18.75c3.25-1,6.15-.6,8.25,1.18,5.17,4.37,4.18,15.89-2.19,25.53q-.7,1.06-1.47,2.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "160.69 156.42 152.73 151.78 149.38 170.54 157.34 175.17 160.69 156.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "168.08 156.97 168.08 156.97 168.08 156.97 168.08 156.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.08,157l-7.91-4.6a8.82,8.82,0,0,0-7.44-.59l8,4.64A8.82,8.82,0,0,1,168.08,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.33,180.55l7.95,4.65-7.94-10-8-4.63,7.94,10Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "230.99 221.31 135.17 276.63 135.17 274.49 230.99 219.16 230.99 221.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "230.99 194.09 135.17 249.41 135.17 247.27 230.99 191.95 230.99 194.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.32,236.85l-17.33,10c-1.4.81-2.53-.05-2.53-1.92v-7.17a6.08,6.08,0,0,1,2.53-4.85l17.33-10c1.4-.81,2.54.05,2.54,1.91V232A6.08,6.08,0,0,1,191.32,236.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.3,218.39,206,228.4c-1.4.81-2.54-.05-2.54-1.92v-7.17a6.09,6.09,0,0,1,2.54-4.85l17.33-10c1.4-.81,2.53,0,2.53,1.91v7.17A6.08,6.08,0,0,1,223.3,218.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M148.73,271.43a1.54,1.54,0,0,0,1.81,0l17.33-10a6.08,6.08,0,0,0,2.54-4.84v-7.18a2.34,2.34,0,0,0-.78-2l-8.47-6.05a1.56,1.56,0,0,0-1.81,0l-17.33,10a6.09,6.09,0,0,0-2.54,4.85v7.17a2.33,2.33,0,0,0,.78,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.87,261.4l-17.33,10c-1.4.81-2.53-.05-2.53-1.92v-7.17a6.08,6.08,0,0,1,2.53-4.85l17.33-10c1.4-.81,2.54.05,2.54,1.91v7.18A6.08,6.08,0,0,1,167.87,261.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M227.54,136.16l-49.06,28.33c-1.84,1.06-3.33-.06-3.33-2.51V149.31a7.94,7.94,0,0,1,3.33-6.34l49.06-28.33c1.84-1.06,3.32.06,3.32,2.51v12.67A7.94,7.94,0,0,1,227.54,136.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M197,148.34l-18.57,10.72c-.45.25-.8,0-.8-.61v0a1.89,1.89,0,0,1,.8-1.53L197,146.16c.44-.26.8,0,.8.6v.05A1.93,1.93,0,0,1,197,148.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M202.21,141.12l-23.8,13.74c-.45.25-.8,0-.8-.61v0a1.89,1.89,0,0,1,.8-1.53l23.8-13.74c.44-.26.8,0,.8.6v.05A1.93,1.93,0,0,1,202.21,141.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M202.21,136.92l-23.8,13.74c-.45.25-.8,0-.8-.61v0a1.89,1.89,0,0,1,.8-1.53l23.8-13.74c.44-.26.8,0,.8.6v0A1.93,1.93,0,0,1,202.21,136.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "237.98 139.05 225.83 146.06 225.83 134.71 237.98 127.69 237.98 139.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "237.98 127.69 237.9 127.74 225.95 120.73 225.95 120.64 213.81 127.65 213.81 139.01 225.83 146.06 225.83 134.71 237.98 127.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237,191.71,212.4,205.93c-2.21,1.28-4-.08-4-3v-27c0-3,1.79-6.37,4-7.65L237,154c2.21-1.28,4,.07,4,3v27C241,187,239.24,190.44,237,191.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.4,202.91v-27c0-3,1.79-6.37,4-7.65L237,154a2.6,2.6,0,0,1,2.53-.26h0l-10-5.65a2.55,2.55,0,0,0-2.59.23l-24.63,14.21c-2.21,1.28-4,4.7-4,7.65v27c0,1.67.58,2.82,1.48,3.28l10,5.65h0C209,205.67,208.4,204.54,208.4,202.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M226.94,179.14a13.16,13.16,0,0,0,3.7-8.46c0-3.78-2.65-5.3-5.92-3.42a13.09,13.09,0,0,0-5.92,10.25c0,2.87,1.53,4.43,3.69,4.2-5,4.07-8.88,11.31-9.12,17.55l22.69-13.1C235.82,180.19,232,177.39,226.94,179.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M265.49,221.78l-34.67,19.34a6.75,6.75,0,0,1-6-.25L204.61,229.2c-1.78-1-2-2.58-.44-3.47l34.67-19.34a6.72,6.72,0,0,1,6,.25l20.2,11.66C266.83,219.33,267,220.89,265.49,221.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M266.5,315V220.55h0a2,2,0,0,1-1,1.23l-34.67,19.34a5.58,5.58,0,0,1-2.79.59v95a5.38,5.38,0,0,0,2.79-.59l34.67-19.34A1.7,1.7,0,0,0,266.5,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M224.8,240.87,204.61,229.2a2.66,2.66,0,0,1-1.44-1.7V322c-.16.77.33,1.61,1.44,2.25l20.19,11.66a7,7,0,0,0,3.23.84v-95A7,7,0,0,1,224.8,240.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M224.8,240.87,204.61,229.2a2.66,2.66,0,0,1-1.44-1.7V322c-.16.77.33,1.61,1.44,2.25l20.19,11.66a7,7,0,0,0,3.23.84v-95A7,7,0,0,1,224.8,240.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M285.68,248.83,251,268.73a6.67,6.67,0,0,1-6-.25l-11.53-6.88c-1.78-1-2-2.58-.44-3.47l34.54-19.81a6.72,6.72,0,0,1,6,.25l11.66,6.78C287,246.38,287.21,247.94,285.68,248.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M286.68,251V247.6h0a1.91,1.91,0,0,1-1,1.23L251,268.73a5.33,5.33,0,0,1-2.79.59v3.94a5.33,5.33,0,0,0,2.79-.59l34.68-19.9A1.71,1.71,0,0,0,286.68,251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M245,268.48l-11.53-6.88a2.66,2.66,0,0,1-1.44-1.7v3.4c-.16.76.33,1.61,1.44,2.25L245,272.42a6.74,6.74,0,0,0,3.22.84v-3.94A6.74,6.74,0,0,1,245,268.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M245,268.48l-11.53-6.88a2.66,2.66,0,0,1-1.44-1.7v3.4c-.16.76.33,1.61,1.44,2.25L245,272.42a6.74,6.74,0,0,0,3.22.84v-3.94A6.74,6.74,0,0,1,245,268.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M300.49,269.48l-34.67,19.9a6.67,6.67,0,0,1-6-.25l-11.53-6.87c-1.78-1-2-2.59-.44-3.48L282.38,259a6.72,6.72,0,0,1,6,.25L300.06,266C301.84,267,302,268.59,300.49,269.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M301.5,271.65v-3.4h0a1.89,1.89,0,0,1-1,1.23l-34.67,19.9A5.33,5.33,0,0,1,263,290v3.94a5.33,5.33,0,0,0,2.79-.59l34.67-19.9A1.69,1.69,0,0,0,301.5,271.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M259.81,289.13l-11.53-6.87a2.67,2.67,0,0,1-1.44-1.71V284c-.16.76.33,1.61,1.44,2.25l11.53,6.88a6.85,6.85,0,0,0,3.22.83V290A6.74,6.74,0,0,1,259.81,289.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M259.81,289.13l-11.53-6.87a2.67,2.67,0,0,1-1.44-1.71V284c-.16.76.33,1.61,1.44,2.25l11.53,6.88a6.85,6.85,0,0,0,3.22.83V290A6.74,6.74,0,0,1,259.81,289.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M315.31,290.13,280.64,310a6.7,6.7,0,0,1-6-.24l-11.53-6.88c-1.78-1-2-2.59-.44-3.48l34.54-19.81a6.75,6.75,0,0,1,6,.25l11.66,6.78C316.66,287.68,316.85,289.24,315.31,290.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M316.32,292.3v-3.4h0a1.92,1.92,0,0,1-1,1.23L280.64,310a5.33,5.33,0,0,1-2.79.59v3.95a5.53,5.53,0,0,0,2.79-.59l34.67-19.91A1.69,1.69,0,0,0,316.32,292.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M274.63,309.79l-11.53-6.88a2.67,2.67,0,0,1-1.44-1.71v3.4c-.16.76.33,1.61,1.44,2.25l11.53,6.88a7,7,0,0,0,3.22.84v-3.95A6.85,6.85,0,0,1,274.63,309.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M274.63,309.79l-11.53-6.88a2.67,2.67,0,0,1-1.44-1.71v3.4c-.16.76.33,1.61,1.44,2.25l11.53,6.88a7,7,0,0,0,3.22.84v-3.95A6.85,6.85,0,0,1,274.63,309.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M330.13,310.78l-34.67,19.91a6.73,6.73,0,0,1-6-.25l-11.54-6.88c-1.77-1-2-2.59-.43-3.48L312,300.27a6.75,6.75,0,0,1,6,.25l11.66,6.78C331.48,308.33,331.67,309.89,330.13,310.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M331.14,313v-3.4h0a1.92,1.92,0,0,1-1,1.23l-34.67,19.91a5.53,5.53,0,0,1-2.79.59v3.94a5.53,5.53,0,0,0,2.79-.59l34.67-19.91A1.68,1.68,0,0,0,331.14,313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M289.45,330.44l-11.54-6.88a2.69,2.69,0,0,1-1.43-1.7v3.39c-.16.76.33,1.61,1.43,2.25l11.54,6.88a7,7,0,0,0,3.22.84v-3.94A7,7,0,0,1,289.45,330.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M289.45,330.44l-11.54-6.88a2.69,2.69,0,0,1-1.43-1.7v3.39c-.16.76.33,1.61,1.43,2.25l11.54,6.88a7,7,0,0,0,3.22.84v-3.94A7,7,0,0,1,289.45,330.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M345,331.43l-34.67,19.91a6.73,6.73,0,0,1-6-.25l-11.54-6.88c-1.77-1-2-2.59-.43-3.48l34.54-19.81a6.75,6.75,0,0,1,6,.25L344.52,328C346.3,329,346.49,330.54,345,331.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M346,333.6v-3.4h0a1.92,1.92,0,0,1-1,1.23l-34.67,19.91a5.53,5.53,0,0,1-2.79.59v3.94a5.53,5.53,0,0,0,2.79-.59L345,335.37A1.68,1.68,0,0,0,346,333.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M304.27,351.09l-11.54-6.88a2.69,2.69,0,0,1-1.43-1.7v3.39c-.16.77.33,1.61,1.43,2.25L304.27,355a7,7,0,0,0,3.22.84v-3.94A7,7,0,0,1,304.27,351.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M304.27,351.09l-11.54-6.88a2.69,2.69,0,0,1-1.43-1.7v3.39c-.16.77.33,1.61,1.43,2.25L304.27,355a7,7,0,0,0,3.22.84v-3.94A7,7,0,0,1,304.27,351.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5,227.85c-.05.84,1.21,2,3.12,3.11,2.54,1.47,3.44,3.33,6.59,1.51.9-.52,1.28-.93,1.3-1.29v-2c.09-.91-2.09-1.48-3.92-2.54-2.55-1.46-5.29-2.26-6.59-1.51a.87.87,0,0,0-.5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M230.62,229c-2.54-1.46-3.93-3-2.62-3.8s4,0,6.59,1.51,5.76,2,2.62,3.81S233.16,230.45,230.62,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.57,223c0,.84,1.21,2,3.12,3.11,2.54,1.47,3.45,3.33,6.59,1.51.9-.52,1.28-.93,1.3-1.29v-2c.09-.9-2.09-1.47-3.92-2.53-2.55-1.46-5.29-2.26-6.59-1.51a.87.87,0,0,0-.5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M237.69,224.11c-2.54-1.46-3.93-3.05-2.62-3.8s4,.05,6.59,1.51,5.76,2,2.62,3.81S240.23,225.58,237.69,224.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M231.77,164.59h0a2.09,2.09,0,0,1,2.88.65l8.68,13.81a2.08,2.08,0,0,1-.66,2.87h0a2.08,2.08,0,0,1-2.87-.65l-8.68-13.81A2.09,2.09,0,0,1,231.77,164.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237.46,179.7l2.8,4.45a3.24,3.24,0,0,0,4.45,1h0a3.24,3.24,0,0,0,1-4.45l-2.8-4.46S239.42,174.94,237.46,179.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M238.42,228.33a1.35,1.35,0,0,0,.14-.63V205.89c0-1.38-1.42-2.51-3.16-2.51h0c-1.74,0-3.16,1.13-3.16,2.51v23.72a.8.8,0,0,0,.56.76C234,230.74,236.89,231.26,238.42,228.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.51,223.22a1.56,1.56,0,0,0,.13-.64l-.48-21.8c0-1.38-1.48-2.48-3.21-2.44h0c-1.74,0-3.14,1.19-3.11,2.57l.52,23.72a.8.8,0,0,0,.58.75C241.16,225.72,244,226.18,245.51,223.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.28,209.81a.62.62,0,0,0,.27.09c1.4.11,6.42-1,11.45-6.65a2.66,2.66,0,0,0,.68-1.63V185.54a2.63,2.63,0,0,0-1.13-2.45l-3.78-2.21a2.63,2.63,0,0,0-2.69.25l-5.16,3a8.39,8.39,0,0,0-3.78,6.55v16.17a.81.81,0,0,0,.36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M234.75,185.1a1.32,1.32,0,0,0,.78,1.11,4.17,4.17,0,0,0,3.77,0,1.32,1.32,0,0,0,.77-1.11v-3.5a1.3,1.3,0,0,0-.77-1.1,4.11,4.11,0,0,0-3.77,0,1.29,1.29,0,0,0-.78,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 237.41,
    cy: 176.01,
    r: 7.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M215.78,174.84h0a2.09,2.09,0,0,1,2.94-.22l11.79,10.68a2.1,2.1,0,0,1,.22,2.95h0a2.09,2.09,0,0,1-2.94.22L216,177.78A2.09,2.09,0,0,1,215.78,174.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.1,187.66l4,3.43a3.25,3.25,0,0,0,4.56-.34h0a3.25,3.25,0,0,0-.34-4.56l-4-3.43S225.57,182.53,225.1,187.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M241.55,182.7c-2.32,1.35-4.09.33-4.72-.65-1.58-2.45-1.84-.82-2.78-2-1.24-2-1-4.8-2.68-6.08-2.46-1.84-1.79-5.5,4.63-7.13,8.63-2.2,12,8.67,6.64,14.95A3.21,3.21,0,0,1,241.55,182.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M234.85,180.38c-.62.62-1.31.44-1.53-.41a3,3,0,0,1,.71-2.65c.62-.62,1.3-.43,1.53.41A3,3,0,0,1,234.85,180.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M240.44,362.05l-39.65,22.89a7,7,0,0,1-6.29-.26L153,360.7c-1.85-1.07-2.05-2.7-.45-3.63l39.65-22.89a7,7,0,0,1,6.29.26l41.53,24C241.84,359.49,242.05,361.12,240.44,362.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,362.05l-39.65,22.89a7,7,0,0,1-6.29-.26L153,360.7a2.56,2.56,0,0,1-1.53-2.1h0v1.57a2.53,2.53,0,0,0,1.53,2.12l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.87,1.87,0,0,0,1.08-1.53v-1.57h0A1.88,1.88,0,0,1,240.44,362.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M186.42,356.71l-16,9.23a2.36,2.36,0,0,1-2.14-.09l-10.52-6.08c-.63-.36-.7-.91-.15-1.23l16-9.23a2.38,2.38,0,0,1,2.15.09l10.52,6.07C186.9,355.84,187,356.39,186.42,356.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M213.58,348.13l-37.06,21.4a2.19,2.19,0,0,1-2-.08h0c-.59-.34-.66-.86-.15-1.15l37.07-21.4a2.23,2.23,0,0,1,2,.08h0C214,347.32,214.09,347.84,213.58,348.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M217.65,350.48l-37.06,21.4a2.19,2.19,0,0,1-2-.08h0c-.59-.34-.66-.86-.15-1.15l37.07-21.4a2.19,2.19,0,0,1,2,.08h0C218.1,349.67,218.16,350.19,217.65,350.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M221.72,352.83l-37.06,21.4a2.23,2.23,0,0,1-2-.08h0c-.59-.34-.66-.86-.15-1.15l37.07-21.4a2.19,2.19,0,0,1,2,.08h0C222.17,352,222.23,352.54,221.72,352.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M204.85,367.27l-16.12,9.31a2.25,2.25,0,0,1-2-.08h0c-.59-.34-.65-.86-.14-1.15L202.72,366a2.19,2.19,0,0,1,2,.08h0C205.3,366.46,205.36,367,204.85,367.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M207.36,344.62l-16,9.23a2.35,2.35,0,0,1-2.14-.09l-10.52-6.07c-.63-.37-.7-.92-.15-1.24l16-9.23a2.35,2.35,0,0,1,2.14.09l10.53,6.07C207.84,343.75,207.91,344.3,207.36,344.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M235.5,360.86l-36.93,21.32a2.35,2.35,0,0,1-2.14-.09l-5-2.9c-.64-.37-.71-.92-.16-1.24l36.93-21.32a2.42,2.42,0,0,1,2.14.09l5,2.91C236,360,236.05,360.55,235.5,360.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,364.89l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a2.55,2.55,0,0,1-1.53-2.09h0V363a2.56,2.56,0,0,0,1.53,2.12l41.53,24a7,7,0,0,0,6.29.27l39.65-22.9a1.85,1.85,0,0,0,1.08-1.53v-1.57h0A1.87,1.87,0,0,1,240.44,364.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M240.44,363.64l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a3.15,3.15,0,0,1-1.38-1.42c-.4.88.07,1.91,1.38,2.67l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.7,1.7,0,0,0,.94-2.22A2.12,2.12,0,0,1,240.44,363.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,367.73l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a2.56,2.56,0,0,1-1.53-2.09h0v1.56A2.56,2.56,0,0,0,153,368l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.85,1.85,0,0,0,1.08-1.53v-1.57h0A1.87,1.87,0,0,1,240.44,367.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M240.44,366.48l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a3.15,3.15,0,0,1-1.38-1.42c-.4.88.07,1.91,1.38,2.67l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.71,1.71,0,0,0,.94-2.23A2.09,2.09,0,0,1,240.44,366.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,370.57l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a2.56,2.56,0,0,1-1.53-2.1h0v1.57a2.53,2.53,0,0,0,1.53,2.12l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.87,1.87,0,0,0,1.08-1.53v-1.57h0A1.88,1.88,0,0,1,240.44,370.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M240.44,369.32l-39.65,22.89a7,7,0,0,1-6.29-.26L153,368a3.15,3.15,0,0,1-1.38-1.42c-.4.87.07,1.91,1.38,2.67l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.71,1.71,0,0,0,.94-2.23A2.09,2.09,0,0,1,240.44,369.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,373.41,200.79,396.3a7,7,0,0,1-6.29-.26l-41.53-24a2.56,2.56,0,0,1-1.53-2.1h0v1.57a2.53,2.53,0,0,0,1.53,2.12l41.53,24a7,7,0,0,0,6.29.26L240.44,375a1.87,1.87,0,0,0,1.08-1.53V371.9h0A1.88,1.88,0,0,1,240.44,373.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M240.44,372.16l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a3.15,3.15,0,0,1-1.38-1.42c-.4.87.07,1.91,1.38,2.67l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.71,1.71,0,0,0,.94-2.23A2.09,2.09,0,0,1,240.44,372.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,376.25l-39.65,22.89a7,7,0,0,1-6.29-.26L153,374.9a2.56,2.56,0,0,1-1.53-2.1h0v1.57a2.53,2.53,0,0,0,1.53,2.12l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.87,1.87,0,0,0,1.08-1.53v-1.57h0A1.89,1.89,0,0,1,240.44,376.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M240.44,375l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a3.15,3.15,0,0,1-1.38-1.42c-.4.87.07,1.91,1.38,2.67l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.71,1.71,0,0,0,.94-2.23A2.09,2.09,0,0,1,240.44,375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M240.44,379.09,200.79,402a7,7,0,0,1-6.29-.26l-41.53-24a2.56,2.56,0,0,1-1.53-2.1h0v1.57a2.53,2.53,0,0,0,1.53,2.12l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.87,1.87,0,0,0,1.08-1.53v-1.57h0A1.89,1.89,0,0,1,240.44,379.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M240.44,377.84l-39.65,22.89a7,7,0,0,1-6.29-.26l-41.53-24a3.15,3.15,0,0,1-1.38-1.42c-.4.87.07,1.91,1.38,2.67l41.53,24a7,7,0,0,0,6.29.26l39.65-22.89a1.71,1.71,0,0,0,.94-2.23A2.14,2.14,0,0,1,240.44,377.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M336.08,290.26l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24c1.85-1.07,2.06-2.7.45-3.63l-39.65-22.89a7,7,0,0,0-6.29.26l-41.53,24C334.68,287.7,334.47,289.33,336.08,290.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M336.08,290.26l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24a2.56,2.56,0,0,0,1.53-2.1h0v1.57a2.53,2.53,0,0,1-1.53,2.12l-41.53,24a7,7,0,0,1-6.29.26l-39.65-22.89a1.89,1.89,0,0,1-1.08-1.53v-1.57h0A1.9,1.9,0,0,0,336.08,290.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M362.94,276.34,400,297.74a2.19,2.19,0,0,0,2-.08h0c.59-.34.66-.86.15-1.15l-37.07-21.4a2.19,2.19,0,0,0-2,.08h0C362.49,275.53,362.43,276.05,362.94,276.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M358.87,278.69l37.06,21.4a2.22,2.22,0,0,0,2-.08h0c.58-.34.65-.86.14-1.15L361,277.46a2.19,2.19,0,0,0-2,.08h0C358.42,277.88,358.36,278.4,358.87,278.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M354.8,281l37.06,21.4a2.25,2.25,0,0,0,2-.08h0c.59-.34.65-.86.14-1.15l-37.06-21.4a2.22,2.22,0,0,0-2,.08h0C354.35,280.23,354.29,280.75,354.8,281Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M371.67,295.48l16.12,9.31a2.25,2.25,0,0,0,2-.08h0c.59-.34.65-.86.14-1.15l-16.13-9.31a2.19,2.19,0,0,0-2,.08h0C371.22,294.67,371.16,295.18,371.67,295.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M369.16,272.83l36.93,21.35a2.36,2.36,0,0,0,2.14-.09L418.75,288c.63-.36.7-.91.15-1.23L382,265.43a2.35,2.35,0,0,0-2.14.09l-10.52,6.07C368.68,272,368.61,272.51,369.16,272.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M341,289.07,378,310.39a2.35,2.35,0,0,0,2.14-.09l5-2.9c.63-.37.7-.92.15-1.24l-36.93-21.32a2.42,2.42,0,0,0-2.14.09l-5,2.91C340.54,288.2,340.48,288.76,341,289.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M336.08,293.1,375.73,316a7,7,0,0,0,6.29-.26l41.53-24a2.56,2.56,0,0,0,1.53-2.09h0v1.56a2.56,2.56,0,0,1-1.53,2.13l-41.53,24a7,7,0,0,1-6.29.26l-39.65-22.89a1.87,1.87,0,0,1-1.08-1.53v-1.57h0A1.89,1.89,0,0,0,336.08,293.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M336.08,291.85l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24a3.15,3.15,0,0,0,1.38-1.42c.4.88-.07,1.91-1.38,2.67l-41.53,24a7,7,0,0,1-6.29.26L336.08,293.1a1.71,1.71,0,0,1-.94-2.23A2.14,2.14,0,0,0,336.08,291.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M336.08,295.94l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24a2.56,2.56,0,0,0,1.53-2.09h0v1.56a2.56,2.56,0,0,1-1.53,2.13l-41.53,24a7,7,0,0,1-6.29.26l-39.65-22.89A1.89,1.89,0,0,1,335,296v-1.57h0A1.9,1.9,0,0,0,336.08,295.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M336.08,294.69l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24a3.15,3.15,0,0,0,1.38-1.42c.4.87-.07,1.91-1.38,2.67l-41.53,24a7,7,0,0,1-6.29.26l-39.65-22.89a1.71,1.71,0,0,1-.94-2.23A2.14,2.14,0,0,0,336.08,294.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M336.08,298.78l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24a2.56,2.56,0,0,0,1.53-2.1h0v1.57a2.53,2.53,0,0,1-1.53,2.12L382,323a7,7,0,0,1-6.29.26l-39.65-22.89a1.89,1.89,0,0,1-1.08-1.53v-1.57h0A1.9,1.9,0,0,0,336.08,298.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M336.08,297.53l39.65,22.89a7,7,0,0,0,6.29-.26l41.53-24a3.15,3.15,0,0,0,1.38-1.42c.4.87-.07,1.91-1.38,2.67l-41.53,24a7,7,0,0,1-6.29.26l-39.65-22.89a1.71,1.71,0,0,1-.94-2.23A2.14,2.14,0,0,0,336.08,297.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 267.43,
    cy: 421.08,
    rx: 20.58,
    ry: 11.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M282,429.49c-8,4.64-21.06,4.64-29.1,0-4-2.31-6-5.32-6-8.33v7.33c0,3.06,2,6.13,6,8.47,8,4.64,21.07,4.64,29.1,0,4-2.34,6.06-5.41,6-8.47v-7.33C288,424.17,286,427.18,282,429.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M254.8,417.81c7-4,18.29-4,25.27,0a10.28,10.28,0,0,1,4.89,5.28c1.12-3.26-.51-6.77-4.89-9.3-7-4-18.29-4-25.27,0-4.38,2.53-6,6-4.89,9.3A10.28,10.28,0,0,1,254.8,417.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.07,417.81c-7-4-18.29-4-25.27,0a10.28,10.28,0,0,0-4.89,5.28,10.26,10.26,0,0,0,4.89,5.29c7,4,18.29,4,25.27,0a10.3,10.3,0,0,0,4.89-5.29A10.37,10.37,0,0,0,280.07,417.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.91,344h-2.34v-2.34a.78.78,0,0,0-1.56,0V344h-2.34a.78.78,0,1,0,0,1.56H262v2.34a.78.78,0,0,0,1.56,0v-2.34h2.34a.78.78,0,1,0,0-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.71,363.24h-2.35V360.9a.77.77,0,0,0-.77-.78.78.78,0,0,0-.78.78v2.34h-2.35a.78.78,0,0,0,0,1.56h2.35v2.34a.78.78,0,0,0,.78.78.77.77,0,0,0,.77-.78V364.8h2.35a.78.78,0,0,0,0-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.67,388h-2.34v-2.34a.78.78,0,1,0-1.56,0V388h-2.34a.78.78,0,1,0,0,1.56h2.34v2.35a.78.78,0,0,0,1.56,0v-2.35h2.34a.78.78,0,0,0,0-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.27,406.4h-2.35v-2.34a.77.77,0,0,0-.77-.78.78.78,0,0,0-.78.78v2.34H268a.78.78,0,0,0,0,1.56h2.35v2.34a.78.78,0,0,0,.78.78.77.77,0,0,0,.77-.78V408h2.35a.78.78,0,0,0,0-1.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 271.15,
    cy: 352.55,
    r: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.91,379.4a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,278.91,379.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M266.45,397.72a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,266.45,397.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M272.05,384.87a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,272.05,384.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M259.32,379.4a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,259.32,379.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M265.65,364.4a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,265.65,364.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M277.25,340.33a1.66,1.66,0,1,1-1.66-1.66A1.67,1.67,0,0,1,277.25,340.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M260.55,335.3a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,260.55,335.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.8,
    y: 355.21,
    width: 5.9,
    height: 5.9,
    transform: "translate(-177.76 287.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 267.44,
    y: 326.94,
    width: 5.9,
    height: 5.9,
    transform: "translate(-154.07 287.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.3,
    y: 389.22,
    width: 5.9,
    height: 5.9,
    transform: "translate(-196.1 310.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 262.7,
    y: 371.07,
    width: 5.9,
    height: 5.9,
    transform: "translate(-186.66 297.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M249.6,420.66c-.19,2.77,1.52,5.59,5.2,7.71,7,4,18.29,4,25.27,0,3.67-2.12,5.39-4.94,5.19-7.71V294.5c.2-2.78-1.52-5.6-5.19-7.72-7-4-18.29-4-25.27,0-3.68,2.12-5.39,4.94-5.2,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M123.47,222l-73,42.16c-5.72,3.3-10.39,11.4-10.39,18v8.77c0,6.6,4.67,9.3,10.39,6l54.34-31.38-3.3,17.16,18.81-26.11,3.17-1.83c5.72-3.3,10.39-11.4,10.39-18V228C133.86,221.37,129.19,218.67,123.47,222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M122.47,236.28l-71,41c-.74.42-1.34,0-1.34-1h0a3.22,3.22,0,0,1,1.34-2.56l71-41c.74-.43,1.34,0,1.34,1h0A3.21,3.21,0,0,1,122.47,236.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M86.06,266.53,51.27,286.62c-.64.37-1.16,0-1.16-.88v-.47A2.81,2.81,0,0,1,51.27,283L86.06,263c.64-.37,1.16,0,1.16.88v.47A2.79,2.79,0,0,1,86.06,266.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,268.19c0,.27.19.5.54.72.1.07,0-1.43.34-1.18.1.07,4.91,3.82,7.6,3.13a.57.57,0,0,0,.4-.58v-.61c0-.68-1-1.72-2.52-3.22-1.69-1.65-2.78-2.68-5.31-1.22-.73.42-1,.73-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M171.35,266.45c2.05,2,3.17,3.18,2.12,3.79s-3.16-.31-5.32-1.94c-1.89-1.43-4.65-1.6-2.11-3.07S169.66,264.8,171.35,266.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M169.31,265.32l-.13-15.76a1.86,1.86,0,0,0-1.19-1.71l-1.23-.47-5.18,3.44,2.53,1.29a24.13,24.13,0,0,0,.77,8.44s.87,1.77.7,5.91C165.58,266.46,168.34,267.32,169.31,265.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,272c0,.27.18.5.54.72.1.07,0-1.43.33-1.18.1.07,4.92,3.82,7.6,3.13a.56.56,0,0,0,.4-.58v-.61c0-.68-1-1.72-2.51-3.22-1.7-1.65-2.78-2.68-5.32-1.22-.72.42-1,.73-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M163.79,270.22c2.05,2,3.17,3.18,2.11,3.79s-3.15-.31-5.31-1.94c-1.89-1.43-4.65-1.61-2.12-3.07S162.09,268.57,163.79,270.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M161.73,269.27l-.15-18.45-6.1,2,1,3a22.31,22.31,0,0,0,.77,8.09s.87,1.77.7,5.91C158,269.8,160.23,271.07,161.73,269.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M156.27,232.05s6.79-6.18,2.65-17.17l-3.18,11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M164.31,247.1h0a2,2,0,0,1-2.48-1.35l-5.44-18.56a2,2,0,0,1,1.35-2.48h0a2,2,0,0,1,2.48,1.35l5.45,18.56A2,2,0,0,1,164.31,247.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M158.76,242.16l9.23,5.69s-3.21-.78-11.47,8l-9.07-5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M148.64,251.36a.54.54,0,0,0,.26.09c1.33.1,6.14-.95,10.95-6.37a2.49,2.49,0,0,0,.66-1.56V228.13a2.52,2.52,0,0,0-1.08-2.34l-3.62-2.11a2.51,2.51,0,0,0-2.58.23l-4.93,2.85a8,8,0,0,0-3.63,6.27v15.48a.78.78,0,0,0,.35.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M149.19,227.72a1.24,1.24,0,0,0,.74,1.05,4,4,0,0,0,3.61,0,1.26,1.26,0,0,0,.75-1.05v-3.36a1.28,1.28,0,0,0-.75-1.06,4,4,0,0,0-3.61,0,1.27,1.27,0,0,0-.74,1.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 151.74,
    cy: 219.01,
    r: 7.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M153.82,232.05s-5.23-5.76-1.6-16.42l6.5,2.23s2.24-5.54-5.11-7.14c0,0-4.91-1.07-6.62,3,0,0-3.94.32-2.45,8.42C144.54,222.13,144.76,229.81,153.82,232.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "170.91 247.01 157.68 254.63 147.53 249.09 161.07 241.34 170.91 247.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "170.91 247.01 172.99 233.74 158.3 242.22 157.68 254.63 170.91 247.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M160.3,247.56h0a2,2,0,0,1-2.82-.22L145,232.71a2,2,0,0,1,.22-2.82h0a2,2,0,0,1,2.82.22l12.49,14.64A2,2,0,0,1,160.3,247.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M263.44,260.42c-.24.1-.33.39-.35.8,0,.12,1.2-.7,1.16-.28,0,.12-.88,6,1,7.91a.56.56,0,0,0,.68.06l.51-.29c.6-.29,1-1.64,1.52-3.66.59-2.22.94-3.63-1.5-5.07-.7-.41-1.1-.51-1.33-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M267.94,265c-.71,2.69-1.17,4.19-2.19,3.59s-1.24-2.81-.89-5.41c.3-2.28-.87-4.69,1.58-3.25S268.53,262.74,267.94,265Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M283.71,247.8l-5,1.84-2,2.31a21.55,21.55,0,0,0-6.46,4.51s-1.08,1.58-4.65,3.41c0,0,0,2.49,2.22,2.9l14.32-8.24a3.65,3.65,0,0,0,1.79-2.75A15.87,15.87,0,0,0,283.71,247.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M273.15,273.1c0,.25.18.48.53.69.09.07,0-1.39.32-1.14.1.07,4.77,3.7,7.37,3a.54.54,0,0,0,.39-.56v-.59c0-.66-.94-1.67-2.44-3.12-1.64-1.6-2.69-2.61-5.15-1.19-.71.41-1,.71-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M279.32,271.41c2,1.94,3.07,3.08,2.05,3.67s-3.06-.3-5.15-1.88c-1.83-1.39-4.51-1.56-2.05-3S277.68,269.81,279.32,271.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M277.32,270.48l-.14-17.88-4.85,1.57-.05,3.26a21.46,21.46,0,0,0,.75,7.84s.84,1.72.67,5.73C273.7,271,275.87,272.23,277.32,270.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M290.55,245.42h0a1.94,1.94,0,0,1-2.56-1l-7.68-17a1.94,1.94,0,0,1,1-2.56h0a1.94,1.94,0,0,1,2.57,1l7.68,17A1.94,1.94,0,0,1,290.55,245.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "291.3 243.49 279.28 236.55 279.28 226.86 291.3 233.8 291.3 243.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "288.34 240.88 288.34 233.52 288.6 233.67 288.6 241.02 288.34 240.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "287.76 238.36 287.76 233.18 288.02 233.33 288.02 238.51 287.76 238.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "287.18 239.64 287.18 232.85 287.44 233 287.44 239.78 287.18 239.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "286.6 239.87 286.6 232.51 286.86 232.66 286.86 240.02 286.6 239.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "286.02 234.87 286.02 232.18 286.27 232.33 286.27 235.02 286.02 234.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M269.18,248.42V255s7.74,2.61,15-6.61V242Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M272.68,250.47a.73.73,0,0,0,.25.08c1.3.1,6-.92,10.63-6.18a2.45,2.45,0,0,0,.63-1.51V227.94a2.45,2.45,0,0,0-1.05-2.28l-3.5-2a2.47,2.47,0,0,0-2.51.22l-4.78,2.77a7.78,7.78,0,0,0-3.51,6.08v15a.75.75,0,0,0,.34.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M274,227.53a1.21,1.21,0,0,0,.72,1,3.86,3.86,0,0,0,3.5,0,1.24,1.24,0,0,0,.73-1v-3.25a1.23,1.23,0,0,0-.73-1,3.86,3.86,0,0,0-3.5,0,1.2,1.2,0,0,0-.72,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M260.84,248.88h0a1.94,1.94,0,0,1-.86-2.6l8.44-16.72a1.94,1.94,0,0,1,2.6-.85h0a1.94,1.94,0,0,1,.86,2.6L263.44,248A1.93,1.93,0,0,1,260.84,248.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M282.81,217.24l2.44,9.49a1.1,1.1,0,0,1-1.49,1.3l-5.63-2.34a1.09,1.09,0,0,1-.66-1.24l1.84-9.33a1.11,1.11,0,0,1,2-.37l1.34,2.19A1,1,0,0,1,282.81,217.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M274.24,222.92c0,.81-.57,1.14-1.27.74a2.85,2.85,0,0,1-1.28-2.21c0-.81.58-1.14,1.28-.73A2.8,2.8,0,0,1,274.24,222.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-103",
    cx: 276.48,
    cy: 219.05,
    r: 6.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M269.86,220s5.76,3.16,8.56-5a4.73,4.73,0,0,0,5.25,2.7,6.69,6.69,0,0,0-5.58-6.45S268.24,210.17,269.86,220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M273,220.23l2.45,9.49A1.11,1.11,0,0,1,274,231l-5.63-2.35a1.11,1.11,0,0,1-.66-1.23l1.85-9.34a1.11,1.11,0,0,1,2-.36l1.34,2.18A1.17,1.17,0,0,1,273,220.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M312.23,366.11h0a1.89,1.89,0,0,0,2.48-.94l6.05-13.33a1.87,1.87,0,0,0-.93-2.48h0a1.87,1.87,0,0,0-2.48.93l-6.05,13.34A1.88,1.88,0,0,0,312.23,366.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M315.46,352l2-4.3a2.91,2.91,0,0,1,3.84-1.44h0a2.91,2.91,0,0,1,1.44,3.84l-1.95,4.3S317.78,356,315.46,352Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M324.28,366.17a1.15,1.15,0,0,1,.14.57v6.36c0,1.24-1.25,2.27-2.81,2.3h0a2.61,2.61,0,0,1-2.87-2.21l0-8.08a.72.72,0,0,1,.5-.69A4,4,0,0,1,324.28,366.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M337.59,378.81c.75.33.25,2.29.28,4.18,0,2.64-.52,5.14-1.68,5.84a.8.8,0,0,1-.78.08l-1.17-.65c-.69-.34-1.15-1.88-1.78-4.19-.7-2.55-1.12-4.16,1.68-5.84.8-.48,1.26-.59,1.52-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M332.46,384.07c.84,3.07,1.38,4.8,2.54,4.1s1.41-3.24,1-6.22c-.37-2.61.95-5.4-1.84-3.72S331.76,381.52,332.46,384.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M331.93,381.69a1.34,1.34,0,0,1-.56-.16l-11.54-6.4a2.61,2.61,0,0,1-.59-3.58h0a2.61,2.61,0,0,1,3.34-1.39l13,7.23a.72.72,0,0,1,.36.77A4,4,0,0,1,331.93,381.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M330.16,391.17c.08.82-1.88,1.33-3.52,2.28-2.28,1.32-4.74,2-5.92,1.36a.79.79,0,0,1-.44-.65v-1.34c0-.76,1.08-1.91,2.8-3.59,1.89-1.84,3.09-3,5.91-1.35.81.46,1.14.81,1.14,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M323.08,389.23c-2.28,2.23-3.53,3.54-2.36,4.22s3.52-.34,5.92-2.16c2.1-1.59,5.18-1.78,2.35-3.41S325,387.39,323.08,389.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M324.9,387.62a1.22,1.22,0,0,1-.13-.57V367.47a2.61,2.61,0,0,1,2.84-2.26h0a2.61,2.61,0,0,1,2.84,2.26v21.29a.71.71,0,0,1-.51.69A4,4,0,0,1,324.9,387.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M329.51,371a.62.62,0,0,1-.24.08c-1.25.09-5.76-.89-10.28-6a2.33,2.33,0,0,1-.61-1.46V349.2a2.38,2.38,0,0,1,1-2.21l3.39-2a2.4,2.4,0,0,1,2.42.22l4.63,2.68a7.52,7.52,0,0,1,3.39,5.88v14.52a.75.75,0,0,1-.32.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M328.2,348.8a1.2,1.2,0,0,1-.7,1,3.73,3.73,0,0,1-3.38,0,1.18,1.18,0,0,1-.7-1v-3.14a1.15,1.15,0,0,1,.7-1,3.73,3.73,0,0,1,3.38,0,1.17,1.17,0,0,1,.7,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M341,369.46h0a1.89,1.89,0,0,0,.83-2.52l-6.61-13.07a1.87,1.87,0,0,0-2.52-.82h0a1.86,1.86,0,0,0-.82,2.51l6.6,13.07A1.89,1.89,0,0,0,341,369.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M332,358.09l-2.13-4.22a2.92,2.92,0,0,1,1.28-3.9h0a2.92,2.92,0,0,1,3.9,1.28l2.13,4.22S336.54,358.78,332,358.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M319.16,340.64a6.59,6.59,0,1,0,6.59-6.59A6.59,6.59,0,0,0,319.16,340.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M331.24,332.85c5.63,1.93,2.83,10.16-1.26,13.12-2-1.09.43-3.05-2.3-1.69-.55-2.65.68-1.84-.06-5.17-2.87,1.49-8.44-.32-9.31-3.08,1-.44,2.05-3.27,4.38-4.31C325.69,330.38,329.53,331,331.24,332.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M328,344.34c0,.79.55,1.11,1.23.71a2.7,2.7,0,0,0,1.23-2.13c0-.79-.55-1.1-1.23-.71A2.72,2.72,0,0,0,328,344.34Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppDevelopment);
export default __webpack_public_path__ + "static/media/mobile-app-development.bd83d1a8d1bcbae442706b926025d97f.svg";
export { ForwardRef as ReactComponent };